'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = create;

var _loggerBuilder = require('./logger-builder');

var _loggerBuilder2 = _interopRequireDefault(_loggerBuilder);

var _env = require('./env');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a logger instance, initialized with application name.
 *
 * @param {String} appName application name (will be used as an application identifier in the monitoring tool, e.g. Grafana)
 * @param {Boolean} isWidgetLogger
 */
function create(appName) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$baseUrl = _ref.baseUrl,
      baseUrl = _ref$baseUrl === undefined ? null : _ref$baseUrl,
      _ref$appId = _ref.appId,
      appId = _ref$appId === undefined ? null : _ref$appId,
      _ref$isWidgetLogger = _ref.isWidgetLogger,
      isWidgetLogger = _ref$isWidgetLogger === undefined ? false : _ref$isWidgetLogger,
      _ref$errorHandlerTogg = _ref.errorHandlerToggle,
      errorHandlerToggle = _ref$errorHandlerTogg === undefined ? false : _ref$errorHandlerTogg,
      _ref$disableAutoLoadF = _ref.disableAutoLoadFinish,
      disableAutoLoadFinish = _ref$disableAutoLoadF === undefined ? false : _ref$disableAutoLoadF,
      _ref$swallowException = _ref.swallowExceptions,
      swallowExceptions = _ref$swallowException === undefined ? false : _ref$swallowException,
      _ref$interactionTimeo = _ref.interactionTimeout,
      interactionTimeout = _ref$interactionTimeo === undefined ? null : _ref$interactionTimeo,
      _ref$timeoutHook = _ref.timeoutHook,
      timeoutHook = _ref$timeoutHook === undefined ? null : _ref$timeoutHook,
      _ref$startHook = _ref.startHook,
      startHook = _ref$startHook === undefined ? null : _ref$startHook,
      _ref$endHook = _ref.endHook,
      endHook = _ref$endHook === undefined ? null : _ref$endHook,
      _ref$networkAnalysis = _ref.networkAnalysis,
      networkAnalysis = _ref$networkAnalysis === undefined ? false : _ref$networkAnalysis,
      _ref$publisher = _ref.publisher,
      publisher = _ref$publisher === undefined ? null : _ref$publisher;

  var appVersion = typeof (0, _env.env)() !== 'undefined' ? (0, _env.env)().__CI_APP_VERSION__ : null;

  (0, _env.env)().fedops = (0, _env.env)().fedops || {};
  (0, _env.env)().fedops.apps = (0, _env.env)().fedops.apps || {};

  return new _loggerBuilder2.default().setAppName(appName).setAppVersion(appVersion).setBaseUrl(baseUrl).setAppId(appId).setErrorHandlerToggle(errorHandlerToggle).setSwallowExceptions(swallowExceptions).setWidgetLogger(isWidgetLogger).setInteractionTimeout(interactionTimeout).setTimeoutHook(timeoutHook).setStartHook(startHook).setEndHook(endHook).setDisableAutoLoadFinish(disableAutoLoadFinish).setNetworkAnalysis(networkAnalysis).setPublisher(publisher).build();
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/fedops-logger/dist/src/logger-factory.js
// module id = 190
// module chunks = 0